/** El cliente tipado de la API, con el token de MSAL inyectado. */
import { createStudioClient } from "@skein/api-client";
import { apiToken } from "../auth/msal";
import { ENV } from "../env";

export const studio = createStudioClient({ baseUrl: ENV.apiUrl, getToken: apiToken });
